export class ProductWarrantyDuration{
  productId: number;
  laborWarrantyDays?: number;
  partsWarrantyDays?: number;
}
